"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { deepCopy, defineReadOnly } from "@ethersproject/properties";
import { Logger } from "@ethersproject/logger";
import { version } from "./_version";
var logger = new Logger(version);
import { JsonRpcProvider } from "./json-rpc-provider";
var _nextId = 1;
function buildWeb3LegacyFetcher(provider, sendFunc) {
  var fetcher = "Web3LegacyFetcher";
  return function (method, params) {
    var _this = this;
    var request = {
      method: method,
      params: params,
      id: _nextId++,
      jsonrpc: "2.0"
    };
    return new Promise(function (resolve, reject) {
      _this.emit("debug", {
        action: "request",
        fetcher: fetcher,
        request: deepCopy(request),
        provider: _this
      });
      sendFunc(request, function (error, response) {
        if (error) {
          _this.emit("debug", {
            action: "response",
            fetcher: fetcher,
            error: error,
            request: request,
            provider: _this
          });
          return reject(error);
        }
        _this.emit("debug", {
          action: "response",
          fetcher: fetcher,
          request: request,
          response: response,
          provider: _this
        });
        if (response.error) {
          var _error = new Error(response.error.message);
          _error.code = response.error.code;
          _error.data = response.error.data;
          return reject(_error);
        }
        resolve(response.result);
      });
    });
  };
}
function buildEip1193Fetcher(provider) {
  return function (method, params) {
    var _this2 = this;
    if (params == null) {
      params = [];
    }
    var request = {
      method: method,
      params: params
    };
    this.emit("debug", {
      action: "request",
      fetcher: "Eip1193Fetcher",
      request: deepCopy(request),
      provider: this
    });
    return provider.request(request).then(function (response) {
      _this2.emit("debug", {
        action: "response",
        fetcher: "Eip1193Fetcher",
        request: request,
        response: response,
        provider: _this2
      });
      return response;
    }, function (error) {
      _this2.emit("debug", {
        action: "response",
        fetcher: "Eip1193Fetcher",
        request: request,
        error: error,
        provider: _this2
      });
      throw error;
    });
  };
}
export var Web3Provider = /*#__PURE__*/function (_JsonRpcProvider) {
  function Web3Provider(provider, network) {
    var _this3;
    _classCallCheck(this, Web3Provider);
    if (provider == null) {
      logger.throwArgumentError("missing provider", "provider", provider);
    }
    var path = null;
    var jsonRpcFetchFunc = null;
    var subprovider = null;
    if (typeof provider === "function") {
      path = "unknown:";
      jsonRpcFetchFunc = provider;
    } else {
      path = provider.host || provider.path || "";
      if (!path && provider.isMetaMask) {
        path = "metamask";
      }
      subprovider = provider;
      if (provider.request) {
        if (path === "") {
          path = "eip-1193:";
        }
        jsonRpcFetchFunc = buildEip1193Fetcher(provider);
      } else if (provider.sendAsync) {
        jsonRpcFetchFunc = buildWeb3LegacyFetcher(provider, provider.sendAsync.bind(provider));
      } else if (provider.send) {
        jsonRpcFetchFunc = buildWeb3LegacyFetcher(provider, provider.send.bind(provider));
      } else {
        logger.throwArgumentError("unsupported provider", "provider", provider);
      }
      if (!path) {
        path = "unknown:";
      }
    }
    _this3 = _callSuper(this, Web3Provider, [path, network]);
    defineReadOnly(_this3, "jsonRpcFetchFunc", jsonRpcFetchFunc);
    defineReadOnly(_this3, "provider", subprovider);
    return _this3;
  }
  _inherits(Web3Provider, _JsonRpcProvider);
  return _createClass(Web3Provider, [{
    key: "send",
    value: function send(method, params) {
      return this.jsonRpcFetchFunc(method, params);
    }
  }]);
}(JsonRpcProvider);